import React from 'react';
import {
  Box, Button, Form as DSForm,
} from 'vindi-ds-components';
import { VdChevronRight } from 'vindi-ds-icons/vd';
import useSendForm from '@hooks/cadastral_update_send_form';
import validationSchema from '../validations';
import CustomerAddressField from './FormFields/CustomerAddressFields';
import CustomerCepAndStateField from './FormFields/CustomerCepAndStateFields';
import CustomerContactFields from './FormFields/CustomerContactFields';

const initalValues = {
  cep: '',
  email: '',
  phone: '',
  state: '',
  address: '',
  complement: '',
  number: '',
  neighborhood: '',
  city: '',
};

function Form() {
  const { handleSubmit } = useSendForm();

  return (
    <DSForm
      initialValues={initalValues}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchema}
    >
      <CustomerContactFields />
      <CustomerCepAndStateField />
      <CustomerAddressField />
      <Box display='flex' justifyContent='end'>
        <Button size='large' endIcon={<VdChevronRight />} type='submit'>
          Atualizar Cadastro
        </Button>
      </Box>
    </DSForm>
  );
}

export default Form;
